import { render } from "./DocPageSidebarNavItemContent.vue?vue&type=template&id=135d3a81"
import script from "./DocPageSidebarNavItemContent.vue?vue&type=script&lang=js"
export * from "./DocPageSidebarNavItemContent.vue?vue&type=script&lang=js"

import "./DocPageSidebarNavItemContent.vue?vue&type=style&index=0&id=135d3a81&lang=css"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__